/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_LabelInputs */



/**
* | output |
* | --- |
* | "Folder Name" |
*
* @param {Explorer_Display_New_Folder_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_label = /** @type {((inputs?: Explorer_Display_New_Folder_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordnername")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название папки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de la carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダ名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome da pasta")
	return /** @type {LocalizedString} */ ("Folder Name")
});